import { floors } from "./floors";

export function floorSingular(value?: number[]): string {
    return Number(floors(value)) ? 'Piso' : 'Pisos';
}